import React, { useState } from "react";
import { X } from "lucide-react";
import PageHero from "@/components/PageHero";
import { GALLERY } from "@/lib/data";
import { useLang } from "@/lib/i18n";

export default function Gallery() {
  const [active, setActive] = useState(null);
  const { t } = useLang();
  return (
    <div data-testid="gallery-page">
      <PageHero
        eyebrow={t("gallery.eyebrow")}
        title={t("gallery.title")}
        subtitle={t("gallery.subtitle")}
        crumbs={[{ label: t("gallery.eyebrow") }]}
        image="https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=1600&q=80"
      />
      <section className="py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
          {GALLERY.map((g, i) => (
            <button
              key={i}
              onClick={() => setActive(g)}
              className="group block aspect-[4/5] overflow-hidden rounded-2xl border border-black/5 shadow-soft text-left"
              data-testid={`gallery-item-${i}`}
            >
              <img src={g.src} alt={g.caption} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </button>
          ))}
        </div>
      </section>

      {active && (
        <div className="fixed inset-0 z-[70] bg-deep/90 backdrop-blur flex items-center justify-center p-4" onClick={() => setActive(null)} data-testid="lightbox">
          <button className="absolute top-5 right-5 p-2 rounded-full bg-white/10 text-white" aria-label="Close" onClick={() => setActive(null)}>
            <X className="w-6 h-6" />
          </button>
          <img src={active.src} alt={active.caption} className="max-h-[85vh] max-w-full rounded-2xl" />
        </div>
      )}
    </div>
  );
}
